import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { UserModel } from '../../_Models/user/user.model';
import { RoleModel } from '../../_Models/user/role.model';
import { MenuItemModel } from '../../_Models/user/menuItem.model';
import { ChangePassword } from 'src/app/_Models/user/changepassword.model';
import { APIService, HRProfileEnum, RoleEnum, UserType } from 'src/app/components/common/static-data-common';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../common/utility.service';
import { IOAuthService } from '../../_Services/user/iOAuthService';
import { throwError } from 'rxjs';
@Injectable({ providedIn: 'root' })

export class AuthenticationService {
  constructor(private http: HttpClient, private router: Router, private activatedRoute: ActivatedRoute, @Inject('BASE_URL') baseUrl: string, @Inject('IDENTITYSERVER_URL') identityBaseUrl: string, private route: Router, public utility: UtilityService,private oAuthService: IOAuthService) {
    this.url = baseUrl;
    this.identityBaseurl = identityBaseUrl;
    if (this.url.charAt(this.url.length - 1) == '/')
      this.url = this.url.substring(0, this.url.length - 1);

  }

  public url: string;
  public identityBaseurl: string;
  public returnUrl: string;
  public appService: APIService;
  public EntityCount: number = 0;
  /*
  login(username: string, password: string) {
    const body = {
      UserName: username,
      Password: password,
      isEncrypt: true
    };

    return this.http.post<any>(`${this.url}/api/User/SignIn`, body)
      .pipe(map(response => {
        // login successful if there's a jwt token in the response
        if (response && response.result == 1 && response.token) {
          localStorage.setItem('access_token', JSON.stringify(response.token));
          localStorage.setItem('_entity', 'API');
          localStorage.setItem('_entityId', '1');
          return response;
        }
      }));
  }*/

  getCurrentUser(): UserModel {
    var user = JSON.parse(localStorage.getItem('currentUser'));
    if (user && user.rightsDB && localStorage.getItem('currentUser')) {
      user.rights = this.getMenuList(user.rightsDB);
      localStorage.setItem('currentUser', JSON.stringify(user));
    }
    return <UserModel>user;
  }

  changePassword(model: ChangePassword) {
    return this.http.post<any>(`${this.url}/api/User/ChangePassword`, model)
      .pipe(map(response => {
        return response;
      }));
  }
  resetPassword(model: ChangePassword) {
    return this.http.post<any>(`${this.url}/api/User/resetPassword`, model)
      .pipe(map(response => {
        return response;
      }));
  }
  resetPasswordRequest(userId: string) {
    return this.http.post<any>(`${this.url}/api/User/resetPassword/${userId}`, null)
      .pipe(map(response => {
        return response;
      }));
  }

  getUserEntityAccess(userId: Number) {
    return this.http.get<any>(`${this.url}/api/User/EntityAccess/${userId}`)
      .pipe(map(response => {
        return response;
      }));
  }

  getUserRoleEntityAccess(userId: Number, entityId: string) {

    var entityAccessReq = { id: userId, entityId: entityId };

    return this.http.post<any>(`${this.url}/api/User/EntityRoleAccess`, entityAccessReq)
      .pipe(map(response => {
        return response;
      }));
  }


  // redirectToLanding() {
  //   //var EntityName = this.utility.getEntityName();
  //   var user = this.getCurrentUser();
  //   this.getApplicationHeader(user.packageFeatures.find(x => x.name === "Inspection")?.id);
  //   if (user && user.usertype == UserType.InternalUser) {
  //     this.router.navigate(["/api/tenantdashboard/dashbaord"]);
  //   }
  //   else if (user.usertype == UserType.Customer) {
  //     this.router.navigate(["/api/tenantdashboard/dashbaord"]);
  //   }
  //   else if (user.usertype == UserType.Factory) {
  //     if (user.roles.find(x => x.qcRole)) {
  //       this.router.navigate(["/api/calender/calender-summary"]);
  //     }
  //     else {
  //       this.router.navigate(["/api/tenantdashboard/dashbaord"]);
  //     }
  //   }
  //   else if (user.usertype == UserType.Supplier) {
  //     if (user.roles.find(x => x.qcRole)) {
  //       this.router.navigate(["/api/calender/calender-summary"]);
  //     }
  //     else {
  //       this.router.navigate(["/api/tenantdashboard/dashbaord"]);
  //     }
  //   }
  //   else if (user.usertype == UserType.QCCompany) {
  //     if (user.roles.find(x => x.qcRole)) {
  //       this.router.navigate(["/api/calender/calender-summary"]);
  //     }
  //     else {
  //       this.router.navigate(["/api/reportsummary/report-summary"]);
  //     }
  //   }
  //   else {
  //     var redirectPath = this.returnUrl && this.returnUrl != "/" ? this.returnUrl : "/" + "/tenantdashboard/dashbaord";
  //     this.router.navigate([redirectPath]);
  //   }
  // }

  // getApplicationHeader(id: number) {
  //   localStorage.setItem('service', JSON.stringify(id));
  //   var user = this.getCurrentUser();
  //   this.RedirectWithServiceAccess();
  // }

  // redirectToDashboard() {
  //   //var EntityName = this.utility.getEntityName();
  //   this.returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || '/';
  //   var user = this.getCurrentUser();
  //   var redirectPath = '';
  //   if (user && user.usertype == UserType.InternalUser) {


  //     var isInspector = user.profiles.find(x => x == HRProfileEnum.Inspector);

  //     if (isInspector) {
  //       redirectPath = this.returnUrl && this.returnUrl != "/" ? this.returnUrl : "/" + "/qcdashboard";
  //       this.router.navigate([redirectPath]);
  //     }
  //     else {
  //       var management = user.roles.find(x => x.id == RoleEnum.TechnicalTeam || x.id == RoleEnum.OperationTeamManagement || x.id == RoleEnum.HRManagement
  //         || x.id == RoleEnum.KAM || x.id == RoleEnum.CEO || x.id == RoleEnum.SalesTeam);


  //       // if (user.serviceAccess.includes(APIService.Inspection))//inspection
  //       // {
  //       //   if (management) {
  //       //     redirectPath = this.returnUrl && this.returnUrl != "/" ? this.returnUrl : "/" + EntityName + "/managementdashboard/dashboard";
  //       //     this.router.navigate([redirectPath]);
  //       //   }
  //       //   else {
  //       //     this.router.navigate([this.returnUrl && this.returnUrl != "/" ? this.returnUrl : "/" + EntityName + "/cs/dashboard"]);
  //       //   }
  //       // }
  //       //if only audit service and one entity then redirect to respective dashbaord after login.
  //       // else if (user.serviceAccess.includes(APIService.Audit) && this.EntityCount == 1 && this.getAccessCount(user) == 1)//audit + only audit access.
  //       // {
  //       //   var redirectPath = this.returnUrl && this.returnUrl != "/" ? this.returnUrl : "/" + EntityName + "/auditsummary/audit-summary";
  //       //   this.router.navigate([redirectPath]);
  //       // }
  //       //if only Tcf service and one entity then redirect to respective dashbaord after login.
  //       // else if (user.serviceAccess.includes(APIService.Tcf) && this.EntityCount == 1 && this.getAccessCount(user) == 1)//tcf + only tcf access
  //       // {
  //       //   var redirectPath = this.returnUrl && this.returnUrl != "/" ? this.returnUrl : "/" + EntityName + "/tcfdashboard/tcf-dashboard";
  //       //   this.router.navigate([redirectPath]);
  //       // }

  //     }

  //   }
  //   else if (user.usertype == UserType.Customer) {
  //     redirectPath = this.returnUrl && this.returnUrl != "/" ? this.returnUrl : "/" + "/cusdashboard";
  //     this.router.navigate([redirectPath]);
  //   }
  //   else if (user.usertype == UserType.Supplier) {
  //     var redirectPath = this.returnUrl && this.returnUrl != "/" ? this.returnUrl : "/" + "/supdashboard/dashboard";
  //     this.router.navigate([redirectPath]);
  //   }

  // }

  async getLanguages() {
    return await this.http.get<any>(`${this.url}/api/UserProfile`).toPromise();
  }
  /*
  logout() {
    // remove user from local storage to log user out
    var user = JSON.parse(localStorage.getItem('currentUser'));
    if (user) {
      this.logoutLog(user.id)
        .subscribe(res => {

        });
    }
    localStorage.removeItem('currentUser');
    localStorage.removeItem('access_token');
    localStorage.removeItem('serviceType');
    localStorage.removeItem('_activemenuid');
    localStorage.removeItem('_entity');
    localStorage.removeItem('mapbox.eventData.uuid:');
    localStorage.removeItem('recentUploads');

  }

  public logoutLog(logoutId: any) {

     this.http.get<any>(`${this.identityBaseurl}/account/logout?logoutId=`+logoutId).subscribe(x=>{
      console.log(x);
    });
    return this.http.get<any>(`${this.url}/api/User/SignOut/${logoutId}`)
    .pipe(map(response => {
      return response;
    }));


  }*/
public logoutLog(logoutId: any) {

  // this.http.get<any>(`${this.identityBaseurl}account/logout?logoutId=` + logoutId).subscribe(x => {
  //   console.log(x);
  // });
  this.http.get<any>(`${this.url}/api/User/SignOut/${logoutId}`)
  .subscribe({
    next: response => {
      this.oAuthService.logOut();
    },
    error: err => {
      console.error('Logout failed:', err);
    }
  });
}
private clearAllStorage() {
    const itemsToClear = [
        'currentUser',
        'access_token',
        'refresh_token',
        'serviceType',
        '_activemenuid',
        '_entity',
        'service'
    ];

    itemsToClear.forEach(item => {
        localStorage.removeItem(item);
        sessionStorage.removeItem(item);
    });
}

private broadcastLogout() {
    const channel = new BroadcastChannel('auth');
    channel.postMessage('logout');
    channel.close();
}
  getMenuItem(item, data, serviceType) {

    var children = data.filter(x => x.parentId == item.id && x.showMenu);
    var childrenItems: Array<MenuItemModel> = [];

    if (children) {
      for (let item of children) {
        var menuItem = this.getMenuItem(item, data, serviceType);
        if (serviceType && serviceType == APIService.Inspection) {
          if (menuItem.rightType == 1 || menuItem.rightType == null)
            childrenItems.push(menuItem);
        }
        else if (serviceType && serviceType == APIService.Audit) {
          if (menuItem.rightType == 2 || menuItem.rightType == null)
            childrenItems.push(menuItem);
        }
        else if (serviceType && serviceType == APIService.Tcf) {
          if (menuItem.rightType == 3 || menuItem.rightType == null)
            childrenItems.push(menuItem);
        }
        else
          childrenItems.push(menuItem);
      }

    }

    var right: MenuItemModel = {
      id: item.id,
      active: item.active,
      glyphicons: item.glyphicons,
      isExpand: false,
      isHeading: item.isHeading,
      menuName: item.menuName,
      parentId: item.parentId,
      path: item.path && item.path != "" ? item.path : "#",
      ranking: item.ranking,
      titleName: item.titleName,
      children: childrenItems,
      showMenu: item.showMenu,
      rightType: item.rightType,
      applicationId: item.applicationId,
      isFbLink: item.isFbLink
    };

    return right;
  }

  getMenuList(data) {
    var serviceType = Number(localStorage.getItem('service'));
    data = data.filter(x => x.applicationId == serviceType);
    return data;
  }
  RedirectWithServiceAccess() {
    this.router.navigate(["/api/userDashBoard/dashboard"]);
  }

  // RedirectAuditDashboard(){
  //   this.router.navigate(["/api/auditdashboard/Auditdashboard"]);
  // }
  // RedirectAnalyticsDashboard(){
  //   this.router.navigate(["/api/predictive-analysis"]);
  // }
  // RedirectSubscription(){
  //   this.router.navigate(["/api/company/company-details"]);
  // }
  getSettingMenuList(request : any){
 return this.http.post<any>(`${this.url}/api/User/gettting-setting-rights`, request)
      .pipe(map(response => {
        return response;
      }));
  }

   togglePinMenu(request: any) {
    return this.http.post<any>(`${this.url}/api/User/toggle-pin-menu`, request)
      .pipe(map(response => {
        return response;
      }));
  }

  recordMenuAccess(request: any) {
    return this.http.post<any>(`${this.url}/api/User/record-menu-access`, request)
      .pipe(map(response => {
        return response;
      }));
  }
}
